// import { logout } from '@/api/user'
import { getUserInfo, getAuthUserInfo, sendValidCode, getPermission, Login } from '@/api/base'
// getPermission
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter, asyncRoutes } from '@/router'
// import { MessageBox, Message } from 'element-ui'
import Aes from '@/utils/aes'
// import Layout from '@/layout' // 调接口时要打开
const state = {
  token: getToken(),
  userToken: '',
  title: '奕阳教育',
  name: '',
  hasPlatformRole: 0,
  avatar: '',
  introduction: '',
  roles: [],
  logo: '',
  logo2: '',
  shopName: '',
  corpId: '',
  orgid: '',
  deptId: '',
  appId: '',
  // appId: '66789', // 测试
  // appId: '66840', // 正式
  userInfo: {
    userId: '',
    nickName: '',
    avatarUrl: '',
    position: ''
  },
  userReceptionInfo: {
    phone: '',
    userId: '',
    nickName: '',
    orgName: '',
    orgId: '',
    identity: ''
  },
  headerTabIndex: 0,
  matchInfo: {},
  tabIndex: 0
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_TAB_INDEX(state, tabIndex) {
    state.tabIndex = tabIndex
  },
  SET_MATCH_INFO: (state, matchInfo) => {
    state.matchInfo = matchInfo
  },
  SET_HEADER_TAB_INDEX: (state, headerTabIndex) => {
    state.headerTabIndex = headerTabIndex
  },
  SET_USERTOKEN: (state, userToken) => {
    state.userToken = userToken
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name = '用户test') => {
    state.name = name
  },
  SET_HASPLATFORMROLE: (state, hasPlatformRole = 0) => {
    state.hasPlatformRole = hasPlatformRole
  },
  SET_TITLE: (state, title = '竞赛系统') => {
    state.title = title
  },
  SET_SHOPNAME: (state, shopName) => {
    state.shopName = shopName
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar || 'https://shopmanage-prod.oss-cn-shenzhen.aliyuncs.com/manage/logos/logo.png'
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_LOGO: (state, logo) => {
    state.logo = logo || 'https://zhizhiyy.oss-cn-hangzhou.aliyuncs.com/image/logo2.png'
  },
  SET_LOGO2: (state, logo2) => {
    state.logo2 = logo2 || 'https://jiaxiaoshetiyu-prod2.oss-cn-hangzhou.aliyuncs.com/yiyang/admin-logo.png'
  },
  SET_CORPID: (state, corpId) => {
    state.corpId = corpId
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_USERRECEPTIONINFO: (state, userReceptionInfo) => {
    state.userReceptionInfo = userReceptionInfo
  },
  SET_DEPTID: (state, deptId) => {
    state.deptId = deptId
  },
  SET_ORGID: (state, orgId) => {
    state.orgId = orgId
  }
}

const actions = {
  // user login
  login({ commit, dispatch }, userInfo) {
    const { phone, password } = userInfo
    return new Promise((resolve, reject) => {
      Login({ phone: phone.trim(), password: Aes.encrypt(password.trim()) })
        .then((response) => {
          const { data } = response
          setToken(data.token)
          commit('SET_TOKEN', data.token)
          commit('SET_NAME', data.nickName)
          dispatch('getAuthUserInfo')
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getValidCode({ commit }, username) {
    return new Promise((resolve, reject) => {
      sendValidCode({ username })
        .then((response) => {
          if (response.code === '1000') {
            resolve()
          } else {
            reject()
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // get user info
  getPermission({ commit, state }) {
    return new Promise((resolve, reject) => {
      getPermission(state.token)
        .then((response) => {
          const { data } = response
          if (!data) {
            return
          }
          let permissionList = data.length === 0 ? [] : data
          permissionList = [...permissionList, ...['active001']]
          commit('SET_ROLES', permissionList)
          resolve(asyncRoutes)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo(state.token)
        .then((response) => {
          const { avatarUrl, nickName, hasPlatformRole } = response.data
          commit('SET_USERINFO', response.data)
          commit('SET_AVATAR', avatarUrl)
          commit('SET_NAME', nickName)
          commit('SET_HASPLATFORMROLE', hasPlatformRole)
          // commit('SET_DEPTID', departInfo.deptId)
          commit('SET_LOGO', '')
          commit('SET_LOGO2', '')
          // commit('SET_TITLE', departInfo.name)
          resolve(true)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAuthUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getAuthUserInfo()
        .then((response) => {
          const { data } = response
          commit('SET_USERRECEPTIONINFO', data)
          commit('SET_NAME', data.nickName)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_TAB_INDEX', 0)
      commit('SET_ROLES', [])
      commit('SET_NAME', '')
      commit('SET_USERRECEPTIONINFO', {
        phone: '',
        userId: '',
        nickName: '',
        orgName: '',
        orgId: ''
      })
      sessionStorage.removeItem('webLogin')
      removeToken()
      resetRouter()
      dispatch('tagsView/delAllViews', null, { root: true })
      resolve()
    })
  },
  toggleShop({ commit }, shopInfo) {
    return new Promise((resolve, reject) => {
      commit('SET_SHOPNAME', shopInfo.shop_name)
      commit('SET_LOGO', shopInfo.shopUrl)
      resolve()
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getPermission')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
